class FullWidthVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.video?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.els.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
    this.els.close.elements.forEach(close => {
      this.listeners.add(close, `click`, this.handleClose)
    })
  }

  handleTrigger () {
    if (!this.els.source.element.src) {
      this.els.source.elements.forEach(source => {
        source.src = source.dataset.src
      })
      this.els.video.element.load()
    }
    this.els.video.element.play()
  }

  handleClose () {
    this.els.video.element.pause()
  }
}

if (!customElements.get('full-width-video')) {
  customElements.define('full-width-video', FullWidthVideo)
}
